import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

// Platform Super Admin: internal/test workspaces (Platform Owner Access — no subscription) and their operating cost.
export function InternalWorkspaces({ internal, onChanged }) {
  const { reload } = useAuth();
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const create = async () => {
    if (name.trim().length < 2) return toast.error("Enter a workspace name");
    setBusy(true);
    try { await api.post("/platform/workspaces", { name }); toast.success("Internal workspace created — Platform Owner Access, no billing"); setName(""); await reload(); onChanged(); }
    catch (e) { toast.error(apiError(e, "Could not create workspace")); } finally { setBusy(false); }
  };
  const release = async (wid) => {
    try { await api.put(`/platform/companies/${wid}/internal`, { internal: false }); toast.success("Workspace is now treated as a customer"); onChanged(); }
    catch (e) { toast.error(apiError(e, "Failed")); }
  };
  return (
    <div className="sc-card p-5 border-emerald-800/50" data-testid="internal-workspaces-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="label-cap text-emerald-400">Internal / test workspaces — Platform Owner Access</div>
          <div className="text-xs text-slate-400 mt-1">Excluded from MRR, churn and conversion above. Operating cost (30d): <span className="font-mono text-slate-100" data-testid="internal-cost">${internal.est_cost_30d}</span> · {internal.ai_runs_30d} AI reviews · {internal.pages_30d} pages</div>
        </div>
        <div className="flex gap-2">
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="New internal workspace name" className="bg-slate-950/60 border border-slate-800 rounded px-3 py-1.5 text-sm text-slate-100" data-testid="internal-ws-name" />
          <button disabled={busy} onClick={create} className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold px-3 py-1.5 rounded text-sm disabled:opacity-50" data-testid="internal-ws-create">Create</button>
        </div>
      </div>
      <ul className="mt-3 text-sm divide-y divide-slate-800" data-testid="internal-ws-list">
        {internal.workspaces.length === 0 && <li className="py-2 text-slate-500">None yet.</li>}
        {internal.workspaces.map((w) => (
          <li key={w.workspace_id} className="py-2 flex items-center justify-between gap-3">
            <span className="text-slate-100">{w.name} <span className="ml-2 text-[10px] uppercase tracking-wider text-emerald-400 border border-emerald-800 rounded px-1.5 py-0.5">internal/test</span></span>
            <button onClick={() => release(w.workspace_id)} className="text-xs text-slate-400 hover:text-amber-400" data-testid={`internal-release-${w.workspace_id}`}>Treat as customer</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
